export class PlanDetails {
    policyNumber: string;
    issueState: string;
    planName: string;
    riskClass: string;
    faceAmount: number;
    premium: number;
    payMode: string;
    policyStatus: string;
    termPeriod: string;
    initialPaymentMethod: string;
    illustrationUri: string;
    constructor() {
        this.policyNumber = '';
        this.issueState = '';
        this.planName = '';
        this.riskClass = '';
        this.faceAmount = 0;
        this.premium = 0;
        this.payMode = '';
        this.policyStatus = '';
        this.termPeriod = '';
        this.initialPaymentMethod = '';
        this.illustrationUri = '';
    }
}
